import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (typeof SlimSelect === "undefined") return;
    if (this.element.dataset.slimInitialized === "1") return;
    this.element.dataset.slimInitialized = "1";

    this.slim = new SlimSelect({
      select: this.element,
      settings: {
        placeholderText: this.element.dataset.placeholder || "Aucun",
        searchPlaceholder: "Rechercher...",
        searchText: "Pas de résultats",
      },
    });
  }

  disconnect() {
    if (this.slim) {
      try { this.slim.destroy(); } catch (e) {}
      this.slim = null;
    }
  }
}
